import { __awaiter } from "tslib";
import { useSimpleSideView, } from "@tedivo/tedivo-bay-grid-core";
import { getTranslation } from "../../../../app/i18/i18tn";
import globalStore from "../../../../app/stores/globalStore";
export function createSideView(_a) {
    return __awaiter(this, arguments, void 0, function* ({ sizeSummary, baysData, vesselPartsData, v3DParams, offsetBottomBases, lcgVcgTcgAndPairings, containersWithPositions, editActionNode, selectContainerCriteria, bayNumbersDoubleClickAction, }) {
        var _b, _c, _d, _e;
        const root = getComputedStyle(document.body);
        const card = document.createElement("card-element");
        card.titleHtml = "view:sideView.title";
        card.name = "sideView";
        if (editActionNode)
            card.actions = editActionNode;
        try {
            if (lcgVcgTcgAndPairings.cgStats.totalSlotsCount === 0) {
                const empty = document.createElement("div");
                empty.className = "no-slots-defined";
                empty.innerHTML = getTranslation("view:graphicWillDisplaySlotsWhenDefined");
                card.appendChild(empty);
            }
            const symbolsOptions = {
                strokeWidth: 4,
                strokeColor: root.getPropertyValue("--sl-color-neutral-400"),
                fontColor: root.getPropertyValue("--sl-color-neutral-700"),
                fillColor: root.getPropertyValue("--sl-color-neutral-50"),
                shipStrokeColor: root.getPropertyValue("--sl-color-primary-300"),
                pairedNoneContainerColor: root.getPropertyValue("--sl-color-violet-400"),
                pairedAftContainerColor: root.getPropertyValue("--sl-color-teal-400"),
                pairedFwdContainerColor: root.getPropertyValue("--sl-color-neutral-400"),
                warningColor: root.getPropertyValue("--sl-color-warning-700"),
                skyColor: root.getPropertyValue("--sl-color-neutral-0"),
                shipTopColor: (_c = (_b = v3DParams === null || v3DParams === void 0 ? void 0 : v3DParams.params) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.mainColor,
                shipBottomColor: (_e = (_d = v3DParams === null || v3DParams === void 0 ? void 0 : v3DParams.params) === null || _d === void 0 ? void 0 : _d.colors) === null || _e === void 0 ? void 0 : _e.bottomColor,
            };
            /** SVG donwloaded */
            const svgSvg = yield getSideViewSvgElement();
            const svgElementMeasures = getMeasuresFromSvgFileAttributes(svgSvg, "#SideView", {
                paddingShip: { x: 0, y: 150, z: 100 },
                paddingContArea: { x: 0, y: 0, z: 20 },
            });
            const { sideViewSvg, svgBayLevelGroups, missingImportantXcgs } = useSimpleSideView({
                sizeSummary,
                baysData,
                lcgVcgTcgAndPairings,
                symbolsOptions,
                vesselPartsData,
                offsetBottomBases,
                containersWithPositions,
                selectContainerCriteria,
                svgElement: svgSvg,
                svgElementMeasures,
                prefixSymbol: "sideViewSmbc",
                bayNumbersDoubleClickAction,
            });
            sideViewSvg.classList.add("width-100percent");
            card.appendChild(sideViewSvg);
            sideViewSvg.setAttribute("id", "sideViewSvg");
            const legend = document.createElement("div");
            legend.className = "sideview-legend";
            const pairedNoneLabel = document.createElement("span"), pairedFwdLabel = document.createElement("span"), pairedAftLabel = document.createElement("span");
            pairedNoneLabel.className = "sideview-legend-pairedNone";
            pairedFwdLabel.className = "sideview-legend-pairedFwd";
            pairedAftLabel.className = "sideview-legend-pairedAft";
            pairedNoneLabel.innerHTML = getTranslation("view:sideView.containersPairedNone");
            pairedFwdLabel.innerHTML = getTranslation("view:sideView.containersPairedFwd");
            pairedAftLabel.innerHTML = getTranslation("view:sideView.containersPairedAft");
            legend.appendChild(pairedFwdLabel);
            legend.appendChild(pairedAftLabel);
            legend.appendChild(pairedNoneLabel);
            card.appendChild(legend);
            if (missingImportantXcgs) {
                const note = document.createElement("sl-badge");
                note.variant = "warning";
                note.pill = true;
                const missingXcgs = [
                    lcgVcgTcgAndPairings.missingImportantLcgs ? "LCGs" : "",
                    lcgVcgTcgAndPairings.missingImportantTcgs ? "TCGs" : "",
                    lcgVcgTcgAndPairings.missingImportantVcgs ? "Bottom Bases" : "",
                ];
                note.innerHTML = getTranslation("view:errors.missingXcgs", {
                    missingXcgs: missingXcgs.filter(Boolean).join(", "),
                });
                card.appendChild(note);
            }
            if (bayNumbersDoubleClickAction) {
                svgBayLevelGroups.forEach((group) => {
                    group.svgGroup.addEventListener("click", () => {
                        bayNumbersDoubleClickAction(group.svgGroup);
                    });
                });
            }
        }
        catch (e) {
            console.error(e);
        }
        return card;
    });
}
export function getSideViewSvgElement() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!globalStore.sideViewSvg) {
            const svgg = yield fetch("/assets/images/Container-Ship-V11_F2_R.svg");
            const svggText = yield svgg.text();
            const parser = new DOMParser();
            const svgDoc = parser.parseFromString(svggText, "image/svg+xml");
            const svgSvg = svgDoc.documentElement;
            globalStore.sideViewSvg = svgSvg;
            return svgSvg;
        }
        else {
            return Promise.resolve(globalStore.sideViewSvg);
        }
    });
}
export function getMeasuresFromSvgFileAttributes(svgElement, idOfMainGroup, prevMeasures) {
    const svgOfDeck = svgElement.querySelector(idOfMainGroup);
    if (!svgOfDeck) {
        throw new Error("SVG element not found");
    }
    const lcgNormalization = Number(svgOfDeck.getAttribute("data-total-width") || "1500");
    return Object.assign(Object.assign({}, prevMeasures), { lcgNormalization, totalHeight: Number(svgOfDeck.getAttribute("data-total-height") || "0"), areaContsAft: Number(svgOfDeck.getAttribute("data-aft") || "0"), areaContsFwd: Number(svgOfDeck.getAttribute("data-fwd") || lcgNormalization), deckWidth: Number(svgOfDeck.getAttribute("data-deck-width") || "0"), deckPadWidth: Number(svgOfDeck.getAttribute("data-deck-pad-width") || "0"), sideHeight: Number(svgOfDeck.getAttribute("data-ship-body-height") || "0"), paddingShip: Object.assign({ x: 0, y: 0, z: 0 }, prevMeasures === null || prevMeasures === void 0 ? void 0 : prevMeasures.paddingShip), paddingContArea: Object.assign({ x: 0, y: 0, z: 0 }, prevMeasures === null || prevMeasures === void 0 ? void 0 : prevMeasures.paddingContArea), translatedPartsX: Number(svgOfDeck.getAttribute("data-translated-xs") || "0"), translatedPartsY: Number(svgOfDeck.getAttribute("data-translated-ys") || "0"), bowTopHeight: Number(svgOfDeck.getAttribute("data-bowtop-height") || "0"), parts: {
            bridge: {
                length: Number(svgOfDeck.getAttribute("data-part-bridge-length") || "0"),
                width: Number(svgOfDeck.getAttribute("data-part-bridge-width") || "0"),
            },
            smokestack: {
                length: Number(svgOfDeck.getAttribute("data-part-smokestack-length") || "0"),
                width: Number(svgOfDeck.getAttribute("data-part-smokestack-width") || "0"),
            },
            crane: {
                length: Number(svgOfDeck.getAttribute("data-part-crane-length") || "0"),
                width: Number(svgOfDeck.getAttribute("data-part-crane-width") || "0"),
            },
        } });
}
